// extracted by mini-css-extract-plugin
export default {"container":"rp-z","ratingLayout":"sp-z","ratingLabel":"tp-z","nonInteractiveRatingLabel":"up-z"};